<template>
  <div id="auth_page" class="row white w-100 h-100 align-items-center">
    <div class="col-12 col-md-5 auth">
      <div class="content">
        <img src="@/assets/images/logo.png" id="logo" />

        <form @submit.prevent="submit">
          
          <InputText
            name="username"
            placeholder="E-mail"
            v-model="loginForm.email"
            :error="formErrors.email"
            class="mb-3"
          />

          <InputText
            type="password"
            name="password"
            placeholder="Senha"
            class="mb-3"
            v-model="loginForm.password"
            :error="formErrors.password"
          />

          <router-link :to="{ 'name': 'recovery'}">
          <p class="text-end forgot">Esqueceu sua senha?</p>
          </router-link>

          <PrimaryButtonLoader v-if="loading" class="w-100 d-block mt-4"></PrimaryButtonLoader>
          <PrimaryButton v-else type="submit" class="w-100 d-block mt-4">Entrar</PrimaryButton>
          
          <p v-if="error">{{ errorMessage }}</p>
        </form>
        
      </div>
    </div>
    <div class="col h-100 register">
      <div class="content">
        <h1 class="mb-4">i7 Network | 10 anos</h1>
        <p>
          Unindo vozes, criando conexões, ampliando informações e impulsionando conquistas.
        </p>

        <router-link :to="{ 'name': 'register'}">
          <PrimaryButton class="mt-4">Cadastrar agora</PrimaryButton>
        </router-link>
      </div>
    </div>
    
    <div class="d-block d-md-none mobile-register-footer">
      <p class="mb-0">Não tem cadastro? 
        <router-link :to="{ 'name': 'register'}" class="register-link">
          Cadastre-se
        </router-link>
      </p>
    </div>
  </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { useAuthStore } from '@/stores/AuthStore'
  import { useRouter } from 'vue-router'
  import InputText from '@/components/InputText.vue'
  import PrimaryButton from '@/components/PrimaryButton.vue'
  import PrimaryButtonLoader from '@/components/PrimaryButtonLoader.vue'
  import {errorFormat} from "@/utils/errorFormat";

  const loading = ref(false);

  const loginForm = ref({ email: '', password: '' })
  const authStore = useAuthStore()
  const router = useRouter()

  const formErrors = ref({});
  
  const submit = async () => {
    formErrors.value = {};
    loading.value = true;

    const formResult = await authStore.login(loginForm.value);
    if(formResult.success){
      router.push({ name: 'home' })
    }
    else {
      formErrors.value = errorFormat(formResult.errors);
    }
    loading.value = false;
  }
  </script>

  <style>
  body {
    background-color: #fff !important;
  }
  </style>
  
  <style scoped>
  .mobile-register-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    padding: 20px;
    border-top: 1px solid #d7d7d7;
    text-align: center;
    z-index: 1000;
  }
  
  .register-link {
    color: #583a8e;
    font-weight: 500;
  }
  </style>